module.exports = __webpack_public_path__ + "static/media/logo-inverted.10199c17.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo-inverted.png
 ** module id = 247
 ** module chunks = 0
 **/